import React from 'react';
import { connect } from 'react-redux';
import { selectUgcSummary } from 'app/selectors/bibs/UgcSelector';
import { ugcSummaryShape } from 'app/shapes/bibPage';
import UGCTabs from './UGCTabs';

export class UGCTabsContainer extends React.PureComponent {
  render() {
    return <UGCTabs {...this.props} />;
  }
}

UGCTabsContainer.propTypes = {
  summary: ugcSummaryShape
};

const mapStateToProps = state => ({
  summary: selectUgcSummary(state)
});

export default connect(mapStateToProps)(UGCTabsContainer);
